import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=71961df5&scoped=true"
import script from "./HtmlEditor.vue?vue&type=script&lang=js"
export * from "./HtmlEditor.vue?vue&type=script&lang=js"
import style0 from "./HtmlEditor.vue?vue&type=style&index=0&id=71961df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71961df5",
  null
  
)

export default component.exports